import React, {useState} from 'react'
import {withRouter} from 'react-router-dom'

const Search = ({history, location, isVisible, onPicClick}) => {
  const [inputValue, setInputValue] = useState('');

  const handleInput = event => {
    const newValue = event.target.value;

    setInputValue(newValue);
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (inputValue) {
      history.push({
        pathname: '/catalogue',
        search: encodeURIComponent(inputValue)
      })
    }
  };

  return (
    <form className={`header-main__search ${isVisible ? 'header-main__search_active' : ''}`}
          onClick={event => onPicClick(event, inputValue)} onSubmit={handleSubmit}>
      <input placeholder="Поиск" value={inputValue} onChange={handleInput} onBlur={handleSubmit}/>
      <i className="fa fa-search" aria-hidden="true"/>
    </form>
  )
};

export default withRouter(Search)
